import { writable } from 'svelte/store';
// Models
import BonusBet from '@/Models/BonusBet.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let meta = { pagination: {} };

	const { subscribe, set, update } = writable();

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getFilterMeta() {
			if (meta && meta.pagination) {
				// eslint-disable-next-line no-unused-vars
				const { pagination, ...filterMeta } = meta;
				return filterMeta.bonus_types;
			}
			return meta;
		},

		getUserBonusBets(userId, pagination = null, filter = null) {
			let bonus = new BonusBet();
			// we need a custom resource URL for this endpoint
			bonus.resourceUrl = () => {
				return `${bonus.baseUrl()}/users/${userId}/bonuses`;
			};

			if (filter) {
				for (const [key, value] of Object.entries(filter)) {
					if (value.toString().length) {
						bonus = bonus.where(key, value.toString());
					}
				}
			}

			let results = pagination
				? bonus.orderByDesc('expired_at').paginate(pagination.size, pagination.number)
				: bonus.all();
			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		saveBonusBet(userId, data) {
			let bonus = new BonusBet();
			// we need a custom resource URL for this endpoint
			bonus.resourceUrl = () => {
				return `${bonus.baseUrl()}/users/${userId}/bonuses`;
			};

			return bonus.saveBonus(data).then((results) => {
				return results;
			});
		},

		addBulkBonusToUsers(file, data) {
			let bonus = new BonusBet();

			return bonus
				.doFileUploadRequest(`${bonus.baseUrl()}/bonuses/bulk`, 'bonus_user_list', file, data)
				.then((result) => {
					return result;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
